import { z } from "zod";

// SPEC-204 §3: fecha, acción y referencia son obligatorias; evidencia y
// referencia son texto libre (G-003 — no se adjuntan archivos). Los puntos
// no se digitan (RN-05): no hay campo de puntos en este esquema.
export const registerPointsSchema = z.object({
  actionId: z.string().min(1, "Selecciona la acción"),
  date: z.string().min(1, "Ingresa la fecha"),
  reference: z.string().trim().min(1, "La referencia es obligatoria"),
  evidence: z.string().optional(),
});
export type RegisterPointsValues = z.infer<typeof registerPointsSchema>;

// SPEC-204 §4: anular exige motivo del catálogo y detalle — el contrato
// marca ambos requeridos (20-members-points.yaml:741).
export const voidMovementSchema = z.object({
  adjustmentReasonId: z.string().min(1, "Selecciona el motivo del ajuste"),
  detail: z.string().trim().min(1, "Ingresa el detalle"),
});
export type VoidMovementValues = z.infer<typeof voidMovementSchema>;
